import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { NumberInput as NumberInput$1, InputGroup, InputLeftElement, NumberInputField, InputRightElement, NumberInputStepper, NumberIncrementStepper, NumberDecrementStepper } from '@chakra-ui/react';
var _excluded = ["name", "placeholder", "leftAddOn", "rightAddOn", "setFieldValue", "variant", "isErrored"];
var NumberInput = function NumberInput(_ref) {
  _ref.name;
  var placeholder = _ref.placeholder,
    leftAddOn = _ref.leftAddOn,
    rightAddOn = _ref.rightAddOn,
    setFieldValue = _ref.setFieldValue,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'outline' : _ref$variant,
    isErrored = _ref.isErrored,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(NumberInput$1, _extends({}, rest, {
    variant: isErrored ? "".concat(variant, "Error") : variant,
    onChange: function onChange(val) {
      return setFieldValue === null || setFieldValue === void 0 ? void 0 : setFieldValue(val);
    }
  }), /*#__PURE__*/React.createElement(InputGroup, null, /*#__PURE__*/React.createElement(InputLeftElement, {
    position: "unset",
    w: "auto",
    px: leftAddOn ? 3 : 2
  }, leftAddOn), /*#__PURE__*/React.createElement(NumberInputField, {
    placeholder: placeholder
  }), /*#__PURE__*/React.createElement(InputRightElement, {
    position: "unset",
    w: "auto",
    px: leftAddOn ? 3 : 2
  }, rightAddOn), /*#__PURE__*/React.createElement(NumberInputStepper, null, /*#__PURE__*/React.createElement(NumberIncrementStepper, {
    sx: {
      svg: {
        background: 'transparent'
      }
    }
  }), /*#__PURE__*/React.createElement(NumberDecrementStepper, {
    sx: {
      svg: {
        background: 'transparent'
      }
    }
  }))));
};
NumberInput.displayName = "NumberInput";
export { NumberInput };